import { useQueryClient } from '@tanstack/react-query';
import type { Currency, PrintConfig } from '@matix/types';
import { FALLBACK_CURRENCY } from '@matix/types';
import { PRINT_CONFIG_QUERY_KEY } from './usePrintConfig';

/**
 * Read the resolved base currency for the active session.
 *
 * The PrintConfig query is warmed at login by `usePrintConfig` mounted in
 * the app shell, so this is a synchronous read from the React Query cache.
 * Before PrintConfig has loaded (login race, or a screen that mounts before
 * the warm-up resolves), we return FALLBACK_CURRENCY so callers can render
 * something rather than crash — the actual currency snaps in on the next
 * render once the query settles.
 */
export function useCurrency(): Currency {
  const qc = useQueryClient();
  const data = qc.getQueryData<PrintConfig>(PRINT_CONFIG_QUERY_KEY);
  return data?.currency ?? FALLBACK_CURRENCY;
}
